module.exports = __webpack_public_path__ + "static/media/static-media-info.ef452f5a.png";